/**
 * @generated SignedSource<<e78ddac325648d871abe1e42591de2b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarExperience_project$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentType": "ConditionalFormattingSidebarExperience_project";
};
export type ConditionalFormattingSidebarExperience_project$key = {
  readonly " $data"?: ConditionalFormattingSidebarExperience_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperience_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarExperience_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "24722a997ffa32cc5348dce4b479c001";

export default node;
